<script setup>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const { t } = useI18n();

const tabs = [
  { name: 'canned_list', label: t('CANNED_MGMT.TABS.CANNED') },
  { name: 'canned_whatsapp_templates', label: t('CANNED_MGMT.TABS.WHATSAPP') },
];
</script>

<template>
  <div class="flex gap-2 mt-4">
    <router-link
      v-for="tab in tabs"
      :key="tab.name"
      :to="{ name: tab.name, params: route.params }"
      class="px-3 py-1.5 text-sm rounded-lg"
      :class="
        route.name === tab.name
          ? 'bg-n-alpha-2 text-n-slate-12 font-medium'
          : 'text-n-slate-11 hover:bg-n-alpha-1'
      "
    >
      {{ tab.label }}
    </router-link>
  </div>
</template>
